{
  "list": [
    {
      "policyNumber": "6700642397",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-20T00:00:00.000+02:00",
      "dateEnd": "2021-05-20T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700642330",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-18T00:00:00.000+02:00",
      "dateEnd": "2021-05-18T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700642116",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-17T00:00:00.000+02:00",
      "dateEnd": "2021-05-17T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641852",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-14T00:00:00.000+02:00",
      "dateEnd": "2021-05-14T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641837",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-13T00:00:00.000+02:00",
      "dateEnd": "2021-05-13T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641787",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-10T00:00:00.000+02:00",
      "dateEnd": "2021-05-10T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641449",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-07T00:00:00.000+02:00",
      "dateEnd": "2021-05-07T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641415",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-06T00:00:00.000+02:00",
      "dateEnd": "2021-05-06T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700641266",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-05-04T00:00:00.000+02:00",
      "dateEnd": "2021-05-04T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700640318",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-29T00:00:00.000+02:00",
      "dateEnd": "2021-04-29T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700640227",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-27T00:00:00.000+02:00",
      "dateEnd": "2021-04-27T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700640094",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-26T00:00:00.000+02:00",
      "dateEnd": "2021-04-26T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639708",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-23T00:00:00.000+02:00",
      "dateEnd": "2021-04-23T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639658",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-21T00:00:00.000+02:00",
      "dateEnd": "2021-04-21T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639385",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-19T00:00:00.000+02:00",
      "dateEnd": "2021-04-19T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639302",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-16T00:00:00.000+02:00",
      "dateEnd": "2021-04-16T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639278",
      "scheme": "LN_ramcove zmluvy",
      "rate": 2.2,
      "dateBegin": "2021-04-15T00:00:00.000+02:00",
      "dateEnd": "2021-04-15T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 2.2,
      "tariff": "2LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6700639005",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-13T00:00:00.000+02:00",
      "dateEnd": "2021-04-13T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6634744228",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-08T00:00:00.000+02:00",
      "dateEnd": "2021-04-08T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 8.8,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6634744210",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-07T00:00:00.000+02:00",
      "dateEnd": "2021-04-07T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 8.8,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    },
    {
      "policyNumber": "6634744202",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2021-04-01T00:00:00.000+02:00",
      "dateEnd": "2021-04-01T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.7,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690091282"
    }
  ],
  "allDataFlag": true
}
